import { render } from "./EvidenceOverview.vue?vue&type=template&id=3816be74&scoped=true&ts=true"
import script from "./EvidenceOverview.vue?vue&type=script&lang=ts"
export * from "./EvidenceOverview.vue?vue&type=script&lang=ts"

import "./EvidenceOverview.vue?vue&type=style&index=0&id=3816be74&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3816be74"]])

export default __exports__